import { render, staticRenderFns } from "./KardexPagosv2.vue?vue&type=template&id=144d4952"
import script from "./KardexPagosv2.vue?vue&type=script&lang=js"
export * from "./KardexPagosv2.vue?vue&type=script&lang=js"
import style0 from "./KardexPagosv2.vue?vue&type=style&index=0&id=144d4952&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports